import { useCallback } from 'react';

export const useGetSponsorValue = () =>
  useCallback((totalPrice = 0, paidPrice = 0) => {
    if (totalPrice > 0) {
      return `${Math.round((paidPrice / totalPrice) * 100).toFixed(2)}%`;
    }

    return `$${paidPrice}`;
  }, []);
